import { type CountryWithStates } from '../core/countries';

const defaultPostalCodes: Record<CountryWithStates, Record<string, string>> = {
    US: {
        AA: '34000',
        AE: '09000',
        AK: '99564',
        AL: '35226',
        AP: '96200',
        AR: '71846',
        AS: '96799',
        AZ: '86427',
        CA: '93771',
        CO: '80729',
        CT: '06725',
        DC: '56901',
        DE: '19886',
        FL: '34481',
        FM: '96941',
        GA: '31707',
        GU: '96950',
        HI: '96819',
        IA: '50001',
        ID: '83334',
        IL: '60022',
        IN: '47734',
        KS: '66835',
        KY: '42083',
        LA: '70569',
        MA: '01524',
        MD: '21755',
        ME: '04740',
        MH: '96960',
        MI: '49014',
        MN: '56127',
        MO: '63760',
        MP: '96951',
        MS: '38740',
        MT: '59354',
        NC: '27350',
        ND: '58785',
        NE: '69129',
        NH: '03804',
        NJ: '08341',
        NM: '88312',
        NV: '89074',
        NY: '12859',
        OH: '44630',
        OK: '73064',
        OR: '97034',
        PA: '16637',
        PR: '00624',
        PW: '96940',
        RI: '02883',
        SC: '29602',
        SD: '57224',
        TN: '37640',
        TX: '76248',
        UT: '84516',
        VA: '23842',
        VI: '00804',
        VT: '05051',
        WA: '99356',
        WI: '54217',
        WV: '25979',
        WY: '82945',
    },
    CA: {
        AB: 'T5J 2R7',
        BC: 'V8W 1P6',
        MB: 'R3B 1B9',
        NB: 'E3B 1B5',
        NL: 'A1C 5M2',
        NT: 'X1A 2N4',
        NS: 'B3J 3A5',
        NU: 'X0A 0A1',
        ON: 'M5H 2N2',
        PE: 'C1A 4B7',
        QC: 'G1R 4S9',
        SK: 'S4P 3C8',
        YT: 'Y1A 1C2',
    },
};

export function getDefaultPostalCodeByStateCode(countryCode: CountryWithStates, stateCode: string): string | null {
    return (
        defaultPostalCodes[countryCode as keyof typeof defaultPostalCodes][
            stateCode as keyof (typeof defaultPostalCodes)[typeof countryCode]
        ] ?? null
    );
}
